import Lenis from 'lenis'

const lenis = new Lenis();

window.lenis = lenis;

const scrollLockReasons = new Set();
let wasLenisStoppedBeforeLocks = false;

function syncPageScrollLock() {
  const isLocked = scrollLockReasons.size > 0;

  document.documentElement.classList.toggle('is-scroll-locked', isLocked);

  if (isLocked) {
    window.lenis?.stop?.();
    return;
  }

  if (!wasLenisStoppedBeforeLocks) {
    window.lenis?.start?.();
  }
}

window.pageScrollLock = {
  lock(reason = 'default') {
    if (scrollLockReasons.size === 0) {
      wasLenisStoppedBeforeLocks = Boolean(window.lenis?.isStopped);
    }

    scrollLockReasons.add(reason);
    syncPageScrollLock();
  },

  unlock(reason = 'default') {
    if (!scrollLockReasons.delete(reason)) {
      return;
    }

    syncPageScrollLock();
  },

  has(reason) {
    return scrollLockReasons.has(reason);
  },

  get isLocked() {
    return scrollLockReasons.size > 0;
  },
};

const COOKIE_SCROLL_LOCK = 'cookie-preferences';
const COOKIE_SELECTOR = '.coo.coo--cooc';
const COOKIE_OPEN_SELECTOR = '.coo.coo--cooc.coo--open';
let cookieScrollLockFrame = 0;

function setCookieLenisPrevent() {
  const cookiePanel = document.querySelector(COOKIE_SELECTOR);

  if (!cookiePanel) {
    return false;
  }

  cookiePanel.setAttribute('data-lenis-prevent', '');
  return true;
}

function initCookieLenisPrevent() {
  if (setCookieLenisPrevent()) {
    return;
  }

  const observer = new MutationObserver(() => {
    if (setCookieLenisPrevent()) {
      observer.disconnect();
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
}

function syncCookieScrollLock() {
  const isCookiePanelOpen = Boolean(document.querySelector(COOKIE_OPEN_SELECTOR));

  if (isCookiePanelOpen) {
    window.pageScrollLock.lock(COOKIE_SCROLL_LOCK);
    return;
  }

  window.pageScrollLock.unlock(COOKIE_SCROLL_LOCK);
}

function scheduleCookieScrollLockSync() {
  if (cookieScrollLockFrame) {
    return;
  }

  cookieScrollLockFrame = requestAnimationFrame(() => {
    cookieScrollLockFrame = 0;
    syncCookieScrollLock();
  });
}

function initCookieScrollLock() {
  syncCookieScrollLock();

  const observer = new MutationObserver(scheduleCookieScrollLockSync);

  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class'],
    childList: true,
    subtree: true,
  });
}

initCookieLenisPrevent();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCookieScrollLock, { once: true });
} else {
  initCookieScrollLock();
}

function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}
requestAnimationFrame(raf);
